import { render, staticRenderFns } from "./component-download.vue?vue&type=template&id=05916506&scoped=true&"
import script from "./component-download.vue?vue&type=script&lang=js&"
export * from "./component-download.vue?vue&type=script&lang=js&"
import style0 from "./component-download.vue?vue&type=style&index=0&id=05916506&prod&lang=less&scoped=true&"
import style1 from "./component-download.vue?vue&type=style&index=1&id=05916506&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05916506",
  null
  
)

export default component.exports